import { FC } from 'react';

import { Text } from '@chakra-ui/react';
import { FileBrowserStorageObjectFragment } from '../../graphql/generated';
import { isFile } from '../../graphql/utils/utils';
import { formatTimestamp } from '../../utils/date/date';
import { Placeholder } from './file-browser';

type Props = {
  object: FileBrowserStorageObjectFragment;
};

export const UpdatedAt: FC<Props> = ({ object }) => {
  return isFile(object) && object.createdAt ? (
    <>
      <Text as="span" data-testid="created-timestamp">
        {formatTimestamp(object.createdAt)}
      </Text>
      {object.versions.length > 1 ? (
        <Text color="gray.500" fontSize="sm" data-testid="revised-timestamp">
          Revised&nbsp;&nbsp;
          {formatTimestamp(object.updatedAt)}
        </Text>
      ) : null}
    </>
  ) : (
    <Placeholder />
  );
};
